module.exports = __webpack_public_path__ + "img/pm10_ca.d99af0fa.jpg";